<div *ngIf="isLoading" class="spinner-overlay">
  <div class="spinner">
    <div class="spinner-border"></div>
  </div>
</div>
